import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {LfRoutes} from '@lightweightform/core';
import {ImportFormComponent} from './import-form/import-form.component';
import {ImportComponent} from './import.component';


const routes: LfRoutes = [
  {
    path: '',
    component: ImportComponent,
    children: [
      {path: '', redirectTo: 'import-form', pathMatch: 'full'},
      {path: 'import-form', component: ImportFormComponent},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
